export const UseCasesIndex = ({ categories }) => {
  return (
    <section
      id="use-cases"
      data-testid="use-cases-index"
      className="py-16 sm:py-24 bg-neutral-50 border-t border-neutral-200"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-8 items-end mb-12">
          <div className="lg:col-span-7">
            <span className="font-mono-ui text-[11px] uppercase tracking-[0.22em] text-neutral-500">
              The catalog
            </span>
            <h2 className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl font-black text-neutral-950 tracking-tight">
              {categories.length} categories.{" "}
              <span className="text-neutral-400">
                {categories.reduce((acc, c) => acc + (c.features?.length || 0), 0)} use cases.
              </span>{" "}
              One dashboard.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-base text-neutral-600">
              Every Smarter Spaces deployment starts with the category you need now - and scales to the others without rip-and-replace.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
          {categories.map((c) => (
            <a
              key={c.id}
              href={`#${c.slug || c.id}`}
              data-testid={`use-case-pill-${c.slug || c.id}`}
              className="group block bg-white border border-neutral-200 rounded-lg p-4 hover:border-neutral-900 hover:shadow-md transition-all"
            >
              <div className="flex items-center justify-between">
                <span className="font-mono-ui text-[10px] uppercase tracking-[0.2em] text-neutral-500">
                  {c.index}
                </span>
                <span className="inline-flex items-center justify-center w-6 h-6 rounded-full border border-neutral-200 group-hover:bg-[#84CC16] group-hover:border-[#84CC16] transition-colors">
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round">
                    <path d="M5 12h14" /><path d="M13 5l7 7-7 7" />
                  </svg>
                </span>
              </div>
              <div className="mt-3 font-display text-base font-bold text-neutral-950 leading-tight">
                {c.name}
              </div>
              <div className="mt-1 text-xs text-neutral-500">
                {(c.features?.length || 0)} features
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};
